<template>
  <div id="index-app">
    <!-- <app-header /> -->
    <!-- <div class="header" data-aos="fade-up">
      <img src="~@/assets/banner-500.png"  title=“大数据应用能力成长平台”  alt="大数据应用能力成长平台"/>
    </div> -->

    <div class="content content-one">
      <div class="content-title fade-up delay-400">
        Tempo Talents-成就未来数字人才
      </div>
      <div class="content-des fade-up delay-600">
        大数据应用能力成长平台核心面向大数据管理与应用、数据科学与大数据技术、会计、金融、交通、物流、智能制造等相关交叉学科，应用于教学实践、<br />集中实训、在线竞赛、学习交流等场景。
      </div>
      <div class="content-img fade-up delay-800">
        <img src="~@/assets/ball.png" title=“大数据应用能力成长平台”  alt="大数据应用能力成长平台"/>
      </div>
    </div>
    <div class="content content-two">
      <div
        class="content-title"
        data-aos="fade-up"
        data-aos-delay="300"
        data-aos-offset="100"
      >
        教学实践、项目实训与科研应用一体化平台
      </div>
      <!-- <div
        class="content-des"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-offset="100"
      >
        教学实践、项目实训与科研应用一体化平台
      </div> -->
      <div class="content-img">
        <!-- v-lazy="require('@/assets/课程体系.png')" -->
        <img
          src="~@/assets/课程体系.png" title=“大数据实训平台”  alt="大数据实训平台"
          data-aos="fade-up"
          data-aos-delay="800"
        />
      </div>
    </div>
    <div class="content content-three">
      <div class="content-title" data-aos="fade-up" data-aos-delay="600">
        多行业真实落地项目
      </div>
      <div class="content-des" data-aos="fade-up" data-aos-delay="900">
        100+真实项目实训案例，涵盖几十种典型分析场景，让学生了解行业最新实践与应用场景，通过实战演练提升学生解决实际问题的能力。
      </div>
      <div class="content-img">
        <!-- v-lazy="require('@/assets/真实项目案例100+.png')" -->
        <img
          src="~@/assets/真实项目案例100+.png" title=“大数据行业真实落地项目”  alt="大数据行业真实落地项目"
          data-aos="fade-up"
          data-aos-delay="1200"
        />
        <!-- v-lazy="require('@/assets/多项目.png')" -->
        <img
          src="~@/assets/多项目.png" title=“大数据行业真实落地项目”  alt="大数据行业真实落地项目"
          data-aos="fade-up"
          data-aos-delay="1600"
        />
      </div>
    </div>
    <div class="content content-four" data-aos="fade-up">
      <div class="cover-wrapper">
        <div class="cover-wrapper-item">
          <div class="cover-pic">
            <img src="~@/assets/20191121102535427.png" title=“制造业大数据项目”  alt="制造业大数据项目"/>
          </div>
          <div class="cover-title">制造行业</div>
          <div class="cover-description">
            <p>轮胎质量相关性分析</p>
            <p>基于质检结果的重要燃料供应商预警分析</p>
            <p>基于设备异音检测的质量评估</p>
          </div>
        </div>
        <div class="cover-wrapper-item">
          <div class="cover-pic">
            <img src="~@/assets/20191121102629265.png" title=“能源业大数据项目”  alt="能源业大数据项目"/>
          </div>
          <div class="cover-title">能源行业</div>
          <div class="cover-description">
            <p>基于设备运行状态的重过载精准预测</p>
            <p>大客户用电量分析预测</p>
            <p>联合动力机组齿轮箱故障预测</p>
          </div>
        </div>
        <div class="cover-wrapper-item">
          <div class="cover-pic">
            <img src="~@/assets/20191121102712679.png" title=“金融业大数据项目”  alt="金融业大数据项目"/>
          </div>
          <div class="cover-title">金融行业</div>
          <div class="cover-description">
            <p>客户流失预警</p>
            <p>公私联动的代发薪客户分析</p>
            <p>公募基金精准营销案例</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content content-five">
      <div class="content-header">
        <div class="content-title" data-aos="fade-up" data-aos-delay="600">
          人才能力成长地图
        </div>
        <div class="content-des" data-aos="fade-up" data-aos-delay="900">
          以行业岗位要求为牵引构建DT-CMPA人才能力成长地图，从基础到进阶应用，让学生都掌握能力发展路径和职业规划方向。
        </div>
      </div>

      <div class="content-img">
        <!-- v-lazy="require('@/assets/图片1.png')" -->
        <img
          src="~@/assets/图片1.png" title=“大数据人才”  alt="大数据人才"
          data-aos="fade-up"
          data-aos-delay="1200"
        />
        <!-- v-lazy="require('@/assets/图片2.png')" -->
        <img
          src="~@/assets/图片2.png" title=“大数据人才能力成长地图”  alt="大数据人才能力成长地图"
          data-aos="fade-up"
          data-aos-delay="1500"
        />
      </div>
    </div>
    <div class="content content-six">
      <div class="content-title" data-aos="fade-up" data-aos-delay="600">
        编码式加拖拽式双环境，应用型与开发型兼顾
      </div>

      <div class="content-des" data-aos="fade-up" data-aos-delay="900">
        内置集成多种环境，采用编码式与图形拖拽化方式相结合，满足不同学科、不同阶段的学生的学习需求。
      </div>
      <div class="content-img" data-aos="fade-up" data-aos-delay="1200">
        <img src="~@/assets/image35.gif" title=“编码式”  alt="编码式" class="code-editor" />
        <img src="~@/assets/image36.gif" title=“拖拽式”  alt="拖拽式" class="data-editor" />
        <img src="~@/assets/编码式.png" title=“编码式语言”  alt="编码式语言" class="code-editor-covre" />
        <img src="~@/assets/矢量智能对象.png" title=“Tempo大数据分析平台”  alt="Tempo大数据分析平台" class="data-editor-covre" />
      </div>
    </div>
    <div class="content content-seven">
      <div class="content-title" data-aos="fade-up" data-aos-delay="600">
        开放的数据超市
      </div>
      <div class="content-des" data-aos="fade-up" data-aos-delay="900">
        超过2亿个市场主体的三十余种维度数据类型，满足各类科研、训练的数据使用需求
      </div>
      <div
        class="picture-preview-wrapper"
        data-aos="fade-up"
        data-aos-delay="1200"
      >
        <div class="picture-preview-item">
          <div class="item-icon">
            <img src="~@/assets/形状11拷贝5.png" title=“企业工商数据”  alt="企业工商数据"/>
          </div>
          <div class="item-divider"></div>
          <div class="item-title">企业工商数据</div>
          <div class="item-description">
            <ul>
              <li>2亿市场主体基础工商</li>
              <li>信用数据</li>
            </ul>
          </div>
        </div>
        <div class="picture-preview-item">
          <div class="item-icon">
            <img src="~@/assets/形状683.png" title=“知识产权数据”  alt="知识产权数据"/>
          </div>
          <div class="item-divider"></div>
          <div class="item-title">知识产权</div>
          <div class="item-description">
            <ul>
              <li>商标</li>
              <li>专利</li>
              <li>著作权</li>
            </ul>
          </div>
        </div>
        <div class="picture-preview-item">
          <div class="item-icon">
            <img src="~@/assets/形状681拷贝.png" title=“上市公司数据”  alt="上市公司数据"/>
          </div>
          <div class="item-divider"></div>
          <div class="item-title">上市公司</div>
          <div class="item-description">
            <ul>
              <li>上市公告</li>
              <li>财务指标</li>
              <li>股东信息</li>
              <li>招聘数据</li>
              <li>招投标数据</li>
            </ul>
          </div>
        </div>
        <div class="picture-preview-item">
          <div class="item-icon">
            <img src="~@/assets/形状686.png" title=“高校数据”  alt="高校数据"/>
          </div>
          <div class="item-divider"></div>
          <div class="item-title">高校</div>
          <div class="item-description">
            <ul>
              <li>国家基金项目</li>
              <li>各类人才</li>
            </ul>
          </div>
        </div>
        <div class="picture-preview-item">
          <div class="item-icon">
            <img src="~@/assets/形状690.png" title=“其他数据”  alt="其他数据"/>
          </div>
          <div class="item-divider"></div>
          <div class="item-title">其他数据</div>
          <div class="item-description">
            <ul>
              <li>气象数据</li>
              <li>疫情数据</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content content-eight">
      <div class="content-title" data-aos="fade-up" data-aos-delay="600">
        平台价值
      </div>
      <div class="content-des" data-aos="fade-up" data-aos-delay="900">
        数字经济时代的高质量人才供给，以人才培养为核心，搭建高校、学生、企业协同合作、共同发展的平台。
      </div>
      <div class="content-img" data-aos="fade-up">
        <img
          src="~@/assets/大数据产业.png" title=“大数据产业”  alt="大数据产业"
          data-aos="fade-up"
          data-aos-delay="1200"
        />

        <img
          src="~@/assets/底座.png" title=“数字经济”  alt="数字经济"
          data-aos="fade-up"
          data-aos-delay="1500"
        />

        <img
          src="~@/assets/成就未来数字人才.png" title=“成就未来数字人才”  alt="成就未来数字人才"
          data-aos="fade-up"
          data-aos-delay="1800"
        />

        <img
          src="~@/assets/学校文字.png" title=“高校大数据人才培养”  alt="高校大数据人才培养"
          data-aos="fade-down"
          data-aos-delay="2100"
        />
        <img
          src="~@/assets/学生文字.png" title=“大数据应用能力”  alt="大数据应用能力"
          data-aos="fade-right"
          data-aos-delay="2400"
        />
        <img
          src="~@/assets/老师文字.png" title=“大数据应用能力”  alt="大数据应用能力"
          data-aos="fade-left"
          data-aos-delay="2700"
        />
      </div>
    </div>
    <div class="content-bottom" data-aos="fade-up">
      <div class="bottom-item">
        <div class="bottom-item-title">
          大数据相关专业
        </div>
        <a
          href="http://www.asktempo.com/Tempodata/try.html"
          target="_blank"
          class="bottom-item-link"
          >获取学科建设方案</a
        >
      </div>
      <div class="bottom-item">
        <div class="bottom-item-title">
          交叉学科
        </div>
        <a
          href="http://www.asktempo.com/Tempodata/try.html"
          target="_blank"
          class="bottom-item-link"
          >获取学科建设方案</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/reset.css'
import 'aos/dist/aos.css'
import AOS from 'aos'
// import appHeader from "./components/appHeader.vue";

export default {
  name: 'App',
  components: {},
  mounted() {
    this.$nextTick(() => {
      AOS.init({
        startEvent: 'load',
        offset: 150,
        delay: 50,
        duration: 800,
        mirror: true,
        once: false,
        anchorPlacement: 'top-bottom',
        easing: 'ease-in-out'
      })
    })
  }
  // updated() {
  //   this.$nextTick(() => {
  //     AOS.refreshHard() // This is needed to avoid the un-animate aos effect
  //   })
  // }
}
</script>

<style lang="less">
#index-app {
  text-align: center;
  color: #6575a3;
  width: 100%;
  overflow: hidden;
  .header {
    width: 100%;
    position: relative;
    text-align: center;
    img {
      border: none;
      width: 100%;
      // height: 100%;
      // vertical-align: middle;
    }
  }
  .content {
    padding: 80px 0;
    &:nth-child(2n + 1) {
      background: #f5f7fa;
    }
    .content-title {
      color: #2c3e5c;
      font-weight: bold;
      font-size: 24px;
      line-height: 68px;
    }
    .content-des {
      margin: 0 auto;
      color: #6575a3;
      font-size: 16px;
      line-height: 2;
      margin-bottom: 20px;
    }
  }
  @keyframes fadeUp {
    from {
      transform: translate3d(0, 40px, 0);
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }

  .fade-up {
    animation-duration: 0.8s;
    animation-fill-mode: both;
    animation-name: fadeUp;
  }
  .delay-400 {
    animation-delay: 0.4s;
  }
  .delay-600 {
    animation-delay: 0.6s;
  }
  .delay-800 {
    animation-delay: 0.8s;
  }
  .content-two {
    .content-img {
      max-width: 100%;
    }
  }
  .content-three {
    .content-img {
      margin: 0 auto;
      position: relative;
      img:nth-child(1) {
        position: absolute;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }
    .content-three-row-wrapper {
      width: 100%;
      position: absolute;
      top: 0;
    }
    .content-three-row {
      .content-three-item {
        position: absolute;
        top: 0;
        text-align: left;
        background: #ffffff;
        border: 1px solid #cbcbcb;
        border-radius: 03px 04px;
        box-shadow: -16px 12px 0 #e9f7ff;
        .placeholder {
          display: block;
          height: 08px;
          border-bottom: 1px solid #cbcbcb;
        }
        .title {
          padding: 03px 05px 0;
          color: #507ade;
          font-weight: bold;
        }
        ul {
          display: flex;
          gap: 07px;
          padding: 03px 05px;
          li {
            white-space: nowrap;
            padding-left: 10px;
            position: relative;
            font-size: 07px;
            &::after {
              content: '';
              position: absolute;
              left: 0;
              top: 7px;
              height: 4px;
              width: 4px;
              border-radius: 50%;
              background: #666666;
            }
          }
        }
      }
      &.content-three-row-one {
        .content-three-item:nth-child(1) {
          left: -150px;
        }
        .content-three-item:nth-child(2) {
          left: 80px;
          top: -20px;
        }
        .content-three-item:nth-child(3) {
          top: 50px;
          left: 380px;
        }
      }
      &.content-three-row-two {
        .content-three-item:nth-child(1) {
          top: 150px;
          left: -150px;
        }
        .content-three-item:nth-child(2) {
          top: 150px;
          left: 380px;
        }
      }
      &.content-three-row-three {
        .content-three-item:nth-child(1) {
          top: 300px;
          left: -150px;
        }
        .content-three-item:nth-child(2) {
          top: 300px;
          left: 380px;
        }
      }
      &.content-three-row-three {
        .content-three-item:nth-child(1) {
          top: 300px;
          left: -150px;
        }
        .content-three-item:nth-child(2) {
          top: 300px;
          left: 380px;
        }
      }
      &.content-three-row-four {
        .content-three-item:nth-child(1) {
          top: 450px;
          left: -150px;
        }
        .content-three-item:nth-child(2) {
          top: 450px;
          left: 380px;
        }
      }
      &.content-three-row-five {
        .content-three-item:nth-child(1) {
          top: 600px;
          left: 50px;
        }
        .content-three-item:nth-child(2) {
          top: 600px;
          left: 280px;
        }
      }
    }
  }

  .content-four {
    .cover-wrapper {
      display: flex;
      justify-content: center;
      gap: 14px;
      .cover-wrapper-item {
        .cover-pic {
          // width: 92px;
          // height: 71px;
          // width: 368px;
          // height: 136px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.3s;
          }
          &:hover img {
            transform: scale(1.1);
          }
        }
        .cover-title {
          padding: 23px 0;
          font-size: 20px;
          color: #2c3e5c;
        }
        .cover-description {
          padding-left: 7%;
          p {
            text-align: left;
            font-size: 16px;
            position: relative;
            padding-left: 22px;
            line-height: 40px;
            // width: 80%;
            margin: 0 auto;
            &::before {
              content: '';
              left: 0;
              top: 16px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #009cff;
              position: absolute;
            }
          }
        }
      }
    }
  }
  .content-five {
    position: relative;
    padding: 0;
    .content-header {
      width: 100%;
      text-align: center;
      top: 80px;
      position: absolute;
      z-index: 2;
      .content-title {
        color: #ffffff;
      }
      .content-des {
        color: #ffffff;
      }
    }
    .content-img {
      img:nth-child(1) {
        max-width: 100%;
      }
      img:nth-child(2) {
        margin: auto;
        position: absolute;
        top: 72px;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }
  }
  .content-six {
    .content-img {
      position: relative;
      // height: 100%;
      width: 1000px;
      margin: 0 auto;
      overflow: hidden;
      text-align: left;
      img {
        max-width: 100%;
        display: inline-block;
      }
    }
    .code-editor-covre {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: 160px;
      z-index: 3;
    }
    .data-editor {
      position: absolute;
      top: 0;
      left: 500px;
      z-index: 2;
    }
    .data-editor-covre {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: 160px;
      z-index: 3;
    }
  }
  .content.content-seven {
    background: #121e48;
    .content-title {
      color: #ffffff;
    }
    .content-des {
      color: #ffffff;
    }
    .picture-preview-wrapper {
      display: flex;
      justify-content: center;
      .picture-preview-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 250px;
        height: 420px;
        transition: all 0.3s;
        opacity: 0.9;
        position: relative;
        .item-icon {
          // width: 16px;
          // height: 16px;
          object-fit: contain;
          transform: scale(1);
          transition: all 0.3s;
        }
        .item-divider {
          margin: 30px 0;
          width: 16px;
          height: 2px;
          background: #ffffff;
          transform: scale(1);
          transition: all 0.3s;
        }
        .item-title {
          font-size: 18px;
          color: #ffffff;
          position: relative;
        }

        .item-description {
          transform: scale(0);
          visibility: hidden;
          opacity: 0;
          transition: opacity 0.3s;
          // display: none;
          position: absolute;
          li {
            color: #ffffff;
            font-size: 16px;
            line-height: 30px;
          }
        }
        &:hover {
          opacity: 1;
          position: relative;
          z-index: 10;
          .item-icon,
          .item-divider {
            transform: scale(0);
            visibility: hidden;
          }
          .item-title {
            top: -180px;
            position: relative;
            transform: scale(0.85);
            &::after {
              top: 50px;
              left: 50%;
              transform: translateX(-50%);
              position: absolute;
              content: '';
              width: 16px;
              height: 2px;
              background: linear-gradient(90deg, #01f6ff 0%, #009cff 100%);
            }
          }

          .item-description {
            padding: 10px 0;
            width: 180px;
            transform: scale(1);
            opacity: 1;
            visibility: visible;
            top: 160px;
            border: 1px solid;
            border-image: linear-gradient(
                rgba(1, 246, 255, 0.3),
                rgba(0, 159, 255, 0.3)
              )
              10 10;
            li {
              transform: scale(0.85);
              text-align: center;
            }
          }
        }
        &:nth-child(1) {
          background: url('~@/assets/组40.png') center center no-repeat;
          background-size: cover;
        }
        &:hover:nth-child(1) {
          background: url('~@/assets/企业工商数据-大.png') center center
            no-repeat;
          transform: scale(1.2);
        }
        &:nth-child(2) {
          background: url('~@/assets/组39.png') center center no-repeat;
          background-size: cover;
        }
        &:hover:nth-child(2) {
          background: url('~@/assets/知识产权.png') center center no-repeat;
          transform: scale(1.2);
        }
        &:nth-child(3) {
          background: url('~@/assets/组37.png') center center no-repeat;
          background-size: cover;
        }
        &:hover:nth-child(3) {
          background: url('~@/assets/上市公司-大.png') center center no-repeat;
          transform: scale(1.2);
        }
        &:nth-child(4) {
          background: url('~@/assets/组38.png') center center no-repeat;
          background-size: cover;
        }
        &:hover:nth-child(4) {
          background: url('~@/assets/高校.png') center center no-repeat;
          transform: scale(1.2);
        }
        &:nth-child(5) {
          background: url('~@/assets/组42.png') center center no-repeat;
          background-size: cover;
        }
        &:hover:nth-child(5) {
          background: url('~@/assets/其他数据-大.png') center center no-repeat;
          transform: scale(1.2);
        }
      }
    }
  }
  .content-eight {
    .content-img {
      width: 867px;
      height: 841px;
      margin: 0 auto;
      position: relative;
      margin-bottom: -140px;
      overflow: hidden;
      // text-align: center;
      // position: relative;
      img:nth-child(1) {
        max-width: 100%;
      }
      img:nth-child(n + 2) {
        // display: inline-block;
        display: block;
        margin: 0 auto;
        position: relative;
        z-index: 1;
      }
      img:nth-child(n + 2) {
        position: absolute;
      }

      img:nth-child(2),
      img:nth-child(3) {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // z-index: 2;
      }
      img:nth-child(2) {
        z-index: 2;
      }
      img:nth-child(3) {
        z-index: 3;
      }
      img:nth-child(4) {
        position: absolute;
        top: 240px;
        left: 370px;
        z-index: 4;
      }
      img:nth-child(5) {
        position: absolute;
        top: 400px;
        left: 110px;
        z-index: 4;
      }

      img:nth-child(6) {
        position: absolute;
        top: 400px;
        left: 480px;
        z-index: 4;
      }
    }
  }
  .content-bottom {
    height: 190px;
    background: url('~@/assets/indexeightbg.jpg') center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    gap: 150px;
    .bottom-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .bottom-item-title {
        font-size: 16px;
        color: #fff;
        margin-bottom: 20px;
      }
      .bottom-item-link {
        display: block;
        color: #1474a8;
        text-decoration: none;
        padding: 10px 50px;
        // background: rgba(209, 231, 245, 0.3);
        background-color: rgba(255, 255, 255, 0.79);
        border-radius: 20px;
        position: relative;
        transition: all 0.3s;
        &:hover {
          background-color: #fff;
        }
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -50px;
          width: 100%;
          height: 100%;
          border-radius: 23px;
          background: linear-gradient(
            180deg,
            rgba(209, 231, 245, 0.2) 0%,
            rgba(209, 231, 245, 0.006) 39%
          );
          pointer-events: none;
        }
      }
    }
  }

  @media only screen and (min-width: 1457px) and (max-width: 1650px) {
    .content {
      padding: 60px 0;
      .content-title {
        font-size: 24px;
        line-height: 68px;
      }
      .content-des {
        font-size: 16px;
        line-height: 2;
        margin-bottom: 60px;
      }
    }
    .content-four {
      .cover-title {
        padding: 18px 0;
        font-size: 18px;
      }
      .cover-description {
        p {
          font-size: 14px;
        }
      }
    }
    .content-five {
      .content-img img:nth-child(2) {
        width: 900px;
      }
    }
    .content.content-seven {
      .picture-preview-wrapper {
        .picture-preview-item {
          width: 225px;
          height: 378px;
          .item-divider {
            margin: 16px 0;
          }
          .item-title {
            font-size: 16px;
          }

          .item-description {
            li {
              font-size: 14px;
            }
          }
          &:hover {
            .item-title {
              top: -140px;
              &::after {
                top: 50px;
              }
            }

            .item-description {
              width: 160px;
              top: 160px;
            }
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1025px) and (max-width: 1456px) {
    .content {
      padding: 50px 0;
      .content-title {
        font-size: 22px;
        line-height: 64px;
      }
      .content-des {
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 60px;
      }
    }
    .content-four {
      .cover-wrapper {
        .cover-wrapper-item {
          .cover-title {
            font-size: 16px;
          }
          .cover-description {
            p {
              font-size: 14px;
            }
          }
        }
      }
    }
    .content-five {
      .content-img img:nth-child(2) {
        width: 600px;
      }
    }
    .content.content-seven {
      .picture-preview-wrapper {
        .picture-preview-item {
          width: 175px;
          height: 294px;
          .item-divider {
            margin: 12px 0;
          }
          .item-title {
            font-size: 14px;
          }

          .item-description {
            li {
              font-size: 12px;
            }
          }
          &:hover {
            .item-title {
              top: -130px;

              &::after {
                top: 40px;
              }
            }
            .item-description {
              width: 140px;
              top: 110px;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    .content {
      padding: 50px 0;
      .content-title {
        font-size: 18px;
        line-height: 36px;
      }
      .content-des {
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 60px;
      }
    }
    .content-four {
      .cover-wrapper {
        .cover-wrapper-item {
          .cover-title {
            font-size: 16px;
          }
          .cover-description {
            p {
              font-size: 14px;
            }
          }
        }
      }
    }
    .content-five {
      .content-img img:nth-child(2) {
        max-width: 400px;
      }
    }
    .content.content-seven {
      .picture-preview-wrapper {
        .picture-preview-item {
          width: 175px;
          height: 294px;
          .item-divider {
            margin: 12px 0;
          }
          .item-title {
            font-size: 14px;
          }

          .item-description {
            li {
              font-size: 12px;
            }
          }
          &:hover {
            .item-title {
              top: -130px;

              &::after {
                top: 40px;
              }
            }
            .item-description {
              width: 140px;
              top: 110px;
            }
          }
        }
      }
    }
  }
}
</style>
